import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DeviceParamLirisV3} from "../../../../../../shared/classes/device/type-v3/device-param-liris-v3";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-param-axis-inclino',
    templateUrl: './param-axis-inclino.component.html',
    styleUrls: ['./param-axis-inclino.component.css']
})
export class ParamAxisInclinoComponent implements OnInit {


    axisForm: FormGroup;
    @Input('deviceParamLirisV3') deviceParamLirisV3: DeviceParamLirisV3;
    @Input('editable') editable: boolean = true;

    constructor(private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.axisForm = new FormGroup({
            inclinoAxes: new FormControl(this.deviceParamLirisV3.inclinoAxes),
        });
    }

    setAxisForm() {
        this.deviceParamLirisV3.inclinoAxes = this.axisForm.value.inclinoAxes;
        this.toastr.warning('You changed the axis setting ! Be careful of the channel setting of this sensors', this.translate.instant('WARNING'));
    }

}
